// Import Operations
import calcFields from './calculated/calcFields.js';
import verifyLogic from './verify/verifyLogic.js';
import assignFields from './assign/assignFields.js';
//import reCalc from './reCalc/reCalc.js';

// Import Configuration
import logicData from '../model/logic/logicData.js';

const runLogic = (data, entity, prevData = {}) => {
    let processedData = { ...data }

    //console.log("[runLogic] entity:", entity);

    if (logicData[entity]) {
        const config = logicData[entity]
        for (const operation of config) {
            if (operation.logicType === 'calcFields') {
                processedData = calcFields(processedData, operation, prevData)
            }

            if (operation.logicType === 'verify') {
                processedData = verifyLogic(processedData, operation, prevData)
            }

            if (operation.logicType === 'assignFields') {
                processedData = assignFields(processedData, operation, prevData)
            }

            /*
            Not yet used:
            if (operation.logicType === 'reCalc') {
                            processedData = reCalc(processedData, operation, prevData)
            }*/
        }
    }
    return processedData
}

export default runLogic
